(() => {
  let imageVariantChangeRunning = false;

  document.addEventListener('click', handleVariantImageClick);

  async function handleVariantImageClick(event) {
    const clickedMedia = event.target.closest(
      'button.thumbnail, .thumbnail, [data-target], [data-media-id]'
    );

    if (!clickedMedia) return;

    const productSection = clickedMedia.closest(
      'product-info, [id^="MainProduct-"]'
    );

    if (!productSection) return;

    const mediaId = getMediaId(clickedMedia);

    if (!mediaId) {
      console.warn(
        'Bild-Variantenauswahl: Keine Media-ID gefunden.'
      );
      return;
    }

    /*
     * Verhindert doppelte Ausführung durch verschachtelte Galerieelemente.
     */
    if (imageVariantChangeRunning) return;
    imageVariantChangeRunning = true;

    try {
      /*
       * Bei jedem Klick neu suchen, weil Craft nach einer
       * Variantenänderung Teile des Produktbereichs ersetzen kann.
       */
      const currentProductSection =
        document.querySelector(
          `#${CSS.escape(productSection.id)}`
        ) || productSection;

      const variantPicker = currentProductSection.querySelector(
        'variant-selects'
      );

      if (!variantPicker) {
        console.warn(
          'Bild-Variantenauswahl: variant-selects nicht gefunden.'
        );
        return;
      }

      const variants = getAllVariants(variantPicker);

      if (!variants.length) {
        console.warn(
          'Bild-Variantenauswahl: Keine Variantendaten gefunden.'
        );
        return;
      }

      const matchingVariant = variants.find((variant) => {
        const variantMediaId =
          variant.featured_media?.id ||
          variant.featured_image?.id ||
          variant.featured_image_id;

        return (
          Number(variantMediaId) === Number(mediaId) &&
          variant.available !== false
        );
      });

      if (!matchingVariant) {
        console.warn(
          'Bild-Variantenauswahl: Keine Variante für dieses Bild gefunden.',
          mediaId
        );
        return;
      }

      await selectVariant(
        currentProductSection,
        variantPicker,
        matchingVariant
      );
    } finally {
      window.setTimeout(() => {
        imageVariantChangeRunning = false;
      }, 250);
    }
  }

  function getAllVariants(variantPicker) {
    const variantsJson = variantPicker.querySelector(
      'script[data-all-variants]'
    );

    if (!variantsJson) return [];

    try {
      return JSON.parse(variantsJson.textContent);
    } catch (error) {
      console.error(
        'Bild-Variantenauswahl: Variantendaten sind ungültig.',
        error
      );

      return [];
    }
  }

  function getMediaId(element) {
    const elements = [
      element,
      element.closest('[data-target]'),
      element.closest('[data-media-id]')
    ].filter(Boolean);

    for (const currentElement of elements) {
      const possibleValues = [
        currentElement.dataset.target,
        currentElement.dataset.mediaId,
        currentElement.getAttribute('data-target'),
        currentElement.getAttribute('data-media-id'),
        currentElement.id
      ];

      for (const value of possibleValues) {
        if (!value) continue;

        const match = String(value).match(/(\d+)(?!.*\d)/);

        if (match) {
          return Number(match[1]);
        }
      }
    }

    return null;
  }

  async function selectVariant(
    productSection,
    variantPicker,
    variant
  ) {
    const selects = Array.from(
      variantPicker.querySelectorAll(
        'select[name^="options["]'
      )
    );

    if (!selects.length) {
      console.warn(
        'Bild-Variantenauswahl: Kein Dropdown gefunden.'
      );
      return;
    }

    let lastChangedSelect = null;

    variant.options.forEach((optionValue, optionIndex) => {
      const select = selects[optionIndex];

      if (!select) return;

      const matchingOption = Array.from(select.options).find(
        (option) =>
          normalizeValue(option.value) ===
            normalizeValue(optionValue) ||
          normalizeValue(option.textContent) ===
            normalizeValue(optionValue)
      );

      if (!matchingOption) {
        console.warn(
          'Bild-Variantenauswahl: Dropdown-Wert nicht gefunden:',
          optionValue
        );

        return;
      }

      select.value = matchingOption.value;

      Array.from(select.options).forEach((option) => {
        option.selected = option === matchingOption;
      });

      lastChangedSelect = select;
    });

    if (!lastChangedSelect) return;

    /*
     * Erst das normale Theme-Event auslösen.
     */
    lastChangedSelect.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

    /*
     * Nach dem möglichen Neurendern das aktuelle Formular
     * nochmals suchen und die Varianten-ID absichern.
     */
    await wait(150);

    const refreshedProductSection =
      document.querySelector(
        `#${CSS.escape(productSection.id)}`
      ) || productSection;

    refreshedProductSection
      .querySelectorAll(
        'form[action*="/cart/add"] input[name="id"]'
      )
      .forEach((input) => {
        input.value = variant.id;

        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });

    console.info(
      'Bild-Variantenauswahl: Variante gewählt:',
      variant.title,
      variant.id
    );
  }

  function normalizeValue(value) {
    return String(value ?? '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function wait(milliseconds) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, milliseconds);
    });
  }
})();